<script lang="ts">
  import Button from '$components/elements/Button.svelte';
  import Heading from '$components/elements/Heading.svelte';
  import Review from '$components/elements/Review.svelte';
  import Text from '$components/utils/Text.svelte';
  import type { ReviewInterface } from '$src/types/interfaces';

  import Swiper from '$components/elements/Swiper.svelte';
  import 'swiper/css/pagination';

  let innerWidth = 1280;

  export let reviews: ReviewInterface[];
</script>

<svelte:window bind:innerWidth />

<div class="reviews">
  <div class="reviews__header">
    <div class="reviews__header__heading">
      <Heading>
        <Text key="page.homepage.reviews.heading" />
      </Heading>
    </div>
    <div class="reviews__header__button">
      <Button icon="arrow-right" iconColor="#fff" type="spacious" href="/ohlasy">
        <Text key="page.homepage.reviews.button" />
      </Button>
    </div>
  </div>
  <div class="reviews__carousel">
    <div class="reviews__carousel__stage">
      <Swiper
        spaceBetween={50}
        class="mySwiper"
        breakpoints={{
          0: {
            slidesPerView: 1
          },
          1000: {
            slidesPerView: 2
          }
        }}
        let:Slide
      >
        {#each reviews as review}
          <Slide>
            <Review {review} />
          </Slide>
        {/each}
      </Swiper>
    </div>
  </div>
</div>

<style lang="scss">
  .reviews {
    max-width: 1280px;
    width: 80%;
    margin: 128px auto 98px;
    :global(.swiper-slide) {
      height: auto;
    }
    &__header {
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
    &__carousel {
      width: 1280px;
      max-width: 100%;
      display: grid;
      justify-content: center;
      margin: 32px auto;
      &__stage {
        width: 1280px;
        max-width: 80vw;
      }
    }
  }
  @media screen and (max-width: 1000px) {
    .reviews {
      width: 100%;
      display: grid;
      &__header {
        display: contents;
        &__heading,
        &__button {
          width: 90%;
          margin: 0 auto;
        }
        &__button {
          display: flex;
          justify-content: flex-end;
        }
      }
      &__carousel {
        width: 90vw;
        max-width: 90vw;
        grid-row: 2;
        &__stage {
          width: 100%;
          max-width: 90vw;
          margin: 0 auto;
        }
      }
    }
  }
</style>
